export const CONTENT_FILTERS_STORAGE_KEY = "sabi_rrhh_contenido_filters";

const DEFAULT_FILTERS = {
  categoryFilter: "ALL",
  statusFilter: "ALL",
  searchQuery: "",
};

export function readContenidoFilters() {
  try {
    const raw = sessionStorage.getItem(CONTENT_FILTERS_STORAGE_KEY);
    if (!raw) return DEFAULT_FILTERS;

    return {
      ...DEFAULT_FILTERS,
      ...JSON.parse(raw),
    };
  } catch {
    return DEFAULT_FILTERS;
  }
}

export function saveContenidoFilters(filters) {
  try {
    sessionStorage.setItem(
      CONTENT_FILTERS_STORAGE_KEY,
      JSON.stringify({
        categoryFilter: filters.categoryFilter ?? "ALL",
        statusFilter: filters.statusFilter ?? "ALL",
        searchQuery: filters.searchQuery ?? "",
      })
    );
  } catch {
    //
  }
}

export function clearContenidoFilters() {
  try {
    sessionStorage.removeItem(CONTENT_FILTERS_STORAGE_KEY);
  } catch {
    //
  }
}